// [13.8.2026, 13:49:35] Änderung: Die Standard-Konfiguration wurde um vier neue Texte für das Dienstwünsche-Infofenster erweitert. Zusätzlich sind diese neuen Felder in der Admin-Oberfläche mit Labels und ohne Platzhalter verfügbar.
// [5.8.2026, 07:14:26] Änderung: Die Regelkonfiguration wurde um zwei neue HTML-Textbereiche für die Urlaubs-Zusammenfassung oben und unten erweitert. Zusätzlich wurden diese Felder mit Labels und Platzhaltern für die Admin-Oberfläche registriert.
// [5.8.2026, 06:40:37] Änderung: Es wurde `DEFAULT_INFO_TEXTS` als exportierte Standardkonfiguration für Infotexte ergänzt. Sie enthält HTML-Texte für Startseite, Urlaubsregeln und Dienstregeln inklusive Platzhaltern wie `{maxDays}` und `{urlaubsanspruch}`.
// [4.8.2026, 16:18:49] Änderung: `ruleConfig.ts` wurde neu aufgebaut und definiert nun Standard-Regeltexte, Schwellenwerte sowie Metadaten für die Admin-Oberfläche. Zusätzlich wurde Firestore-Anbindung zum Laden der globalen Regelkonfiguration mit Default-Merge und Fallback-Konfiguration ergänzt.
import { db } from "@/main";
import {
    FirestoreDataConverter,
    doc,
    getDoc,
    setDoc,
} from "firebase/firestore";

// Dokument-ID der globalen Regel-Konfiguration in Firestore
const RULE_CONFIG_DOC = "global";

export const DEFAULT_RULE_MESSAGES: { [key: string]: RuleMessage } = {
    tooManyFruehdienste: { message: "Mehr als {max} Frühdienste innerhalb von {weeks} Wochen gewünscht {date}", shortMessage: "Zuviele Frühdienste" },
    tooManyMitteldienste: { message: "Mehr als {max} Mitteldienste innerhalb von {weeks} Wochen gewünscht {date}", shortMessage: "Zuviele Mitteldienste" },
    tooManySpaetdienste: { message: "Mehr als {max} Spätdienste innerhalb von {weeks} Wochen gewünscht {date}", shortMessage: "Zuviele Spätdienste" },
    tooManyFridays: { message: "Mehr als {max} Freitage Frei innerhalb von {weeks} Wochen gewünscht {date}", shortMessage: "Zuviele Freitage" },
    tooManySaturdays: { message: "Mehr als {max} Samstage Frei innerhalb von {weeks} Wochen gewünscht {date}", shortMessage: "Zuviele Samstage" },
    tooManySundays: { message: "Mehr als {max} Sonntage Frei innerhalb von {weeks} Wochen gewünscht {date}", shortMessage: "Zuviele Sonntage" },
    tooManyMondays: { message: "Mehr als {max} Montage Frei innerhalb von {weeks} Wochen gewünscht {date}", shortMessage: "Zuviele Montage" },
    tooManyFreeDaysTwoWeeks: { message: "Zu viele freie Tage innerhalb von {freeWeeks} Wochen {date}", shortMessage: "Zuviele freie Tage" },
    tooManyConsecutiveWorkdays: { message: "Mehr als {max} aneinanderfolgende Arbeitstage {date}", shortMessage: "Zuviele aneinanderfolgende Arbeitstage" },
    earlyAfterLate: { message: "Frühdienst darf nicht auf Spät oder NE folgen {date}", shortMessage: "Frühdienst auf Spät/NE" },
    afterNE: { message: "Nach einem NE muss ein weiterer NE oder Spät folgen {date}", shortMessage: "Nach NE muss NE/Spät folgen" },
    invalidFreePattern: { message: "Falsches Frei-Schema erkannt {pattern} {date}", shortMessage: "Falsches Frei-Schema" },
    tooFewFreeDays: { message: "Zu wenig Freie Tage innerhalb {weeks} Wochen gewünscht", shortMessage: "Zu wenig Freie Tage innerhalb {weeks} Wochen" },
    tooManyFreeDays: { message: "Zu viele Freie Tage innerhalb {weeks} Wochen gewünscht", shortMessage: "Zu viele Freie Tage innerhalb {weeks} Wochen" },
    vacationMustStartMonday: { message: "Urlaub muss an einem Montag starten {date}", shortMessage: "Urlaub muss an einem Montag starten" },
    vacationMustEndSunday: { message: "Urlaub muss an einem Sonntag enden {date}", shortMessage: "Urlaub muss an einem Sonntag enden" },
    vacationMinDays: { message: "Mindesturlaub von {minDays} Tagen nicht erreicht", shortMessage: "Mindesturlaub von {minDays} Tagen nicht erreicht" },
    vacationMaxDays: { message: "Maximaler Urlaub von {maxDays} Tagen in einer Phase überschritten", shortMessage: "Maximaler Urlaub in einer Phase überschritten" },
    vacationPhasesAdjacent: { message: "Urlaubsphasen {phase1} und {phase2} sind aneinander gereiht und verlängern den Urlaub", shortMessage: "Aneinandergrenzende Urlaubsphasen" },
    tooFewVacationDays: { message: "Zu wenig Urlaubstage gewünscht", shortMessage: "Zu wenig Urlaubstage gewünscht" },
    tooManyVacationDays: { message: "Zuviele Urlaubstage für das ganze Jahr gewünscht", shortMessage: "Zuviele Urlaubstage insgesamt gewünscht" },
};

export const DEFAULT_RULE_THRESHOLDS: RuleConfigThresholds = {
    weekWindow: 8,
    freeDaysWeekWindow: 2,
    vacationMinDays: 7,
    vacationMaxDays: 21,
};

export const DEFAULT_INFO_TEXTS: InfoTexts = {
    home: `<h4 class="mb-2">Liebe Mitarbeiterinnen und Mitarbeiter</h4>
<p>Wir freuen uns, euch eine neue Wunschdienstplan-App zur Verfügung zu stellen, um euch eine einfachere Anwendung zu ermöglichen und vor allem die Darstellung zu vereinfachen. Diese ist daher für eure Mitarbeitersmartphones optimiert worden.</p>
<p>Ihr könnt eure Wünsche zum 8-Wochenplan und die Urlaubswünsche eintragen und speichern. Bitte vergesst nicht das <strong>Speichern</strong> eurer eingegebenen Wünsche aus der Übersicht heraus. Das System unterstützt euch dabei, die geltenden Regeln einzuhalten.</p>
<p>Sollten dabei Fehler auftreten, werdet ihr direkt darauf hingewiesen und könnt diese sofort korrigieren. Ebenfalls haben wir hier die Möglichkeit zur Erstellung von <strong>Vorlagen</strong> für den 8-Wochenplan verwirklicht, die ihr unter euren persönlichen Vorlagen speichern könnt.</p>
<p>Auch werdet ihr zukünftig eure Urlaubswünsche eingeben können, wenn die jeweilige Urlaubseingabeperiode freigegeben ist.</p>
<p>Ein <strong>Video</strong> haben wir euch zur Anwendung erstellt, um die einzelnen Schritte zu erklären.</p>
<p class="font-weight-bold">Viel Freude bei der Nutzung!</p>`,
    vacationRules: `<p>» maximal {maxDays} Tage Urlaub am Stück</p>
<p>» Urlaubsanspruch {urlaubsanspruch}</p>
<p>» im Sommer darf nur die erste oder die zweite Hälfte gewünscht werden</p>
<p><b>Urlaub ab 5 Tagen</b></p>
<p>» Urlaub muss am Montag starten</p>
<p>» Urlaub muss am Sonntag enden</p>`,
    dutyRules: `<p><b>Urlaubsinfo</b></p>
<p>Ab einer Länge von 5 Urlaubstagen werden pro Woche 2 Freie Tage abgezogen</p>`,
    vacationSummaryTop: `<div class="mt-2">Wir werden versuchen deine Wünsche zu erfüllen. Du hast die Möglichkeit, deinen Urlaubswunsch, bis zum {deadline}, zu ändern.</div>
<div class="mt-2">Bitte beachte, dass wir deine Urlaubstage nur <b>schätzen können</b>, da dein 8-Wochenplan aktuell noch nicht final für den Urlaubszeitraum, erstellt wurde.</div>`,
    vacationSummaryBottom: `<div class="mb-2"><small>Wenn du einmal einen außergewöhnlichen Urlaub planst, kontaktiere bitte hierfür gerne die Fahrerdisposition. (Telefonnummer: 02166-6884555)</small></div>
<div><b>Es handelt sich hierbei lediglich um einen Urlaubswunsch. Bitte buche noch keinen Urlaub, solange eine Genehmigung durch den Betriebsrat aussteht! Wir informieren euch rechtzeitig hierüber, wenn der Urlaub offiziell genehmigt wurde.</b></div>`,
    wishInfoTitle: `Regeln`,
    wishInfoTop: ``,
    wishSchemaTitle: `Frei Schematas`,
    wishSchemaSubtitle: `Reihenfolge ist beliebig`,
};

// Beschreibungen und verfügbare Platzhalter je Regel-Text für die Admin-Oberfläche
export interface RuleMessageDefinition {
    key: string;
    label: string;
    placeholders: string[];
    group: string;
}

export const ruleMessageDefinitions: RuleMessageDefinition[] = [
    { key: "tooManyFruehdienste", label: "Zu viele Frühdienste", placeholders: ["{max}", "{weeks}", "{date}"], group: "Dienste" },
    { key: "tooManyMitteldienste", label: "Zu viele Mitteldienste", placeholders: ["{max}", "{weeks}", "{date}"], group: "Dienste" },
    { key: "tooManySpaetdienste", label: "Zu viele Spätdienste", placeholders: ["{max}", "{weeks}", "{date}"], group: "Dienste" },
    { key: "tooManyFridays", label: "Zu viele freie Freitage", placeholders: ["{max}", "{weeks}", "{date}"], group: "Freie Tage" },
    { key: "tooManySaturdays", label: "Zu viele freie Samstage", placeholders: ["{max}", "{weeks}", "{date}"], group: "Freie Tage" },
    { key: "tooManySundays", label: "Zu viele freie Sonntage", placeholders: ["{max}", "{weeks}", "{date}"], group: "Freie Tage" },
    { key: "tooManyMondays", label: "Zu viele freie Montage", placeholders: ["{max}", "{weeks}", "{date}"], group: "Freie Tage" },
    { key: "tooManyFreeDaysTwoWeeks", label: "Zu viele freie Tage in 2 Wochen", placeholders: ["{freeWeeks}", "{date}"], group: "Freie Tage" },
    { key: "tooFewFreeDays", label: "Zu wenig freie Tage im Zeitfenster", placeholders: ["{weeks}"], group: "Freie Tage" },
    { key: "tooManyFreeDays", label: "Zu viele freie Tage im Zeitfenster", placeholders: ["{weeks}"], group: "Freie Tage" },
    { key: "tooManyConsecutiveWorkdays", label: "Zu viele aneinanderfolgende Arbeitstage", placeholders: ["{max}", "{date}"], group: "Sonstige" },
    { key: "earlyAfterLate", label: "Frühdienst auf Spät/NE", placeholders: ["{date}"], group: "Sonstige" },
    { key: "afterNE", label: "Nach NE muss NE/Spät folgen", placeholders: ["{date}"], group: "Sonstige" },
    { key: "invalidFreePattern", label: "Falsches Frei-Schema", placeholders: ["{pattern}", "{date}"], group: "Sonstige" },
    { key: "vacationMustStartMonday", label: "Urlaub muss Montag starten", placeholders: ["{date}"], group: "Urlaub" },
    { key: "vacationMustEndSunday", label: "Urlaub muss Sonntag enden", placeholders: ["{date}"], group: "Urlaub" },
    { key: "vacationMinDays", label: "Mindesturlaub nicht erreicht", placeholders: ["{minDays}"], group: "Urlaub" },
    { key: "vacationMaxDays", label: "Maximaler Urlaub überschritten", placeholders: ["{maxDays}"], group: "Urlaub" },
    { key: "vacationPhasesAdjacent", label: "Aneinandergrenzende Urlaubsphasen", placeholders: ["{phase1}", "{phase2}"], group: "Urlaub" },
    { key: "tooFewVacationDays", label: "Zu wenig Urlaubstage insgesamt", placeholders: [], group: "Urlaub" },
    { key: "tooManyVacationDays", label: "Zu viele Urlaubstage insgesamt", placeholders: [], group: "Urlaub" },
];

// Beschreibungen und verfügbare Platzhalter je Hinweistext für die Admin-Oberfläche
export interface InfoTextDefinition {
    key: keyof InfoTexts;
    label: string;
    placeholders: string[];
}

export const infoTextDefinitions: InfoTextDefinition[] = [
    { key: "home", label: "Startseite", placeholders: [] },
    { key: "vacationRules", label: "Urlaubswünsche (Info-Regeln)", placeholders: ["{maxDays}", "{urlaubsanspruch}"] },
    { key: "dutyRules", label: "Dienstwünsche (Info-Hinweis)", placeholders: [] },
    { key: "vacationSummaryTop", label: "Urlaubs-Zusammenfassung (oben)", placeholders: ["{deadline}"] },
    { key: "vacationSummaryBottom", label: "Urlaubs-Zusammenfassung (unten)", placeholders: [] },
    { key: "wishInfoTitle", label: "Dienstwünsche Info-Fenster: Titel", placeholders: [] },
    { key: "wishInfoTop", label: "Dienstwünsche Info-Fenster: Text oben", placeholders: [] },
    { key: "wishSchemaTitle", label: "Dienstwünsche Info-Fenster: Überschrift Frei-Schemata", placeholders: [] },
    { key: "wishSchemaSubtitle", label: "Dienstwünsche Info-Fenster: Unterzeile Frei-Schemata", placeholders: [] },
];

export function createDefaultRuleConfig(): RuleConfig {
    return {
        messages: structuredClone(DEFAULT_RULE_MESSAGES),
        thresholds: { ...DEFAULT_RULE_THRESHOLDS },
        infoTexts: { ...DEFAULT_INFO_TEXTS },
    };
}

// Fügt fehlende Standard-Texte/-Grenzwerte hinzu, damit neue Regeln nie leer bleiben
function mergeWithDefaults(data: Partial<RuleConfig> | undefined): RuleConfig {
    const base = createDefaultRuleConfig();
    if (!data) return base;

    return {
        messages: { ...base.messages, ...(data.messages || {}) },
        thresholds: { ...base.thresholds, ...(data.thresholds || {}) },
        infoTexts: { ...base.infoTexts, ...(data.infoTexts || {}) },
    };
}

const ruleConfigConverter: FirestoreDataConverter<RuleConfig> = {
    toFirestore(data: RuleConfig) {
        return data;
    },
    fromFirestore(snapshot) {
        return mergeWithDefaults(snapshot.data() as Partial<RuleConfig>);
    },
};

export function GetRuleConfig(): Promise<RuleConfig> {
    return new Promise<RuleConfig>(async (resolve, reject) => {
        try {
            const ref = doc(db, "ruleConfig", RULE_CONFIG_DOC).withConverter(ruleConfigConverter);
            const snapshot = await getDoc(ref);

            if (snapshot.exists()) {
                resolve(snapshot.data() as RuleConfig);
            } else {
                resolve(createDefaultRuleConfig());
            }
        } catch (error) {
            reject(error);
        }
    });
}

export function SetRuleConfig(ruleConfig: RuleConfig): Promise<void> {
    return setDoc(doc(db, "ruleConfig", RULE_CONFIG_DOC), ruleConfig, { merge: true });
}
